/**
 * Zod schemas for runtime validation of puzzles.json.
 * Used by:
 *   - puzzle-loader.ts (browser): validates the fetched file.
 *   - tools/generate-puzzles.ts: validates each generated puzzle before commit.
 */

import { z } from 'zod';

export const archetypeSchema = z.enum([
  'overstate-then-understate',
  'false-deference',
  'theatre-vs-action',
  'fake-collaboration',
  'manufactured-urgency',
  'hierarchy-encoded-passive-aggression',
]);

export const phrasePairSchema = z.object({
  jargon: z.string().min(20).max(220),
  decoded: z.string().min(2).max(140),
  archetype: archetypeSchema,
});

export const puzzleSchema = z.object({
  id: z.string().regex(/^CB-\d{3,}$/),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  phrases: z.array(phrasePairSchema).length(4),
  difficulty: z.number().int().min(1).max(5),
  generated_at: z.string(),
  voice_check_passed: z.boolean(),
  steve_approved: z.boolean(),
  steve_notes: z.string().optional(),
  theme: z.string().optional(),
});

export const puzzlesFileSchema = z.object({
  version: z.literal('1.0.0'),
  generated_at: z.string(),
  generator_model: z.string(),
  puzzles: z.array(puzzleSchema).min(1),
});

export type ParsedPuzzle = z.infer<typeof puzzleSchema>;
export type ParsedPuzzlesFile = z.infer<typeof puzzlesFileSchema>;
